// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2r-1u","infoBtn":"quickbooks_infoBtn__17Bsx","formBox":"quickbooks_formBox__1lJAd","formFooter":"quickbooks_formFooter__AThVl"};